import moment from 'moment'
import { useEventContext } from 'context/EventContext'
import { EventState } from 'graphql/generated'
import { useIsLoggedIn } from 'hooks'
import React from 'react'
import { Typography } from 'components/common'
import { doesUserHaveEventPermissions } from './EventButtons/EnterEventButton'

function NonMemberNotice() {
  const { event } = useEventContext()
  const isLoggedIn = useIsLoggedIn()
  const hasEnded = event.state === EventState.ENDED
  const showRSVPButton =
    isLoggedIn &&
    !hasEnded &&
    !event.isOwner &&
    moment().isBefore(moment(event.startTime))

  const hasPermission = doesUserHaveEventPermissions(event)

  if (!showRSVPButton || event.rsvp || hasPermission) {
    return null
  }

  return (
    <Typography className="text-center mt-4" component="p" color="error">
      {`You'll need to join this DAO to RSVP`}
    </Typography>
  )
}

export default NonMemberNotice
